<template>
    <section class="services-section py-5">
        <div class="container">
            <div class="text-center mb-5">
                <h2 class="section-title">Nasze usługi</h2>
                <p class="section-subtitle">Oferujemy kompleksowe usługi księgowe dla przedsiębiorców</p>
            </div>

            <!-- First row: First 3 services -->
            <div class="row g-4">
                <div class="col-md-6 col-lg-4" v-for="(service, index) in services.slice(0, 3)" :key="index">
                    <div class="service-card h-100">
                        <div class="service-icon mb-3">
                            <i :class="service.icon"></i>
                        </div>
                        <h3 class="service-title">{{ service.title }}</h3>
                        <p class="service-description">{{ service.description }}</p>
                    </div>
                </div>
            </div>

            <!-- Second row: Last 2 services (centered) -->
            <div class="row g-4 mt-0 justify-content-center">
                <div class="col-md-6 col-lg-4" v-for="(service, index) in services.slice(3, 5)" :key="index + 3">
                    <div class="service-card h-100">
                        <div class="service-icon mb-3">
                            <i :class="service.icon"></i>
                        </div>
                        <h3 class="service-title">{{ service.title }}</h3>
                        <p class="service-description">{{ service.description }}</p>
                    </div>
                </div>
            </div>

            <div class="text-center mt-5">
                <router-link to="/oferta" class="btn btn-primary">Zobacz pełną ofertę</router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ServicesSection',
    data() {
        return {
            services: [
                {
                    title: 'Prowadzenie księgowości',
                    description: 'Pełna księgowość, Księga przychodów i rozchodów (KPiR) oraz Ewidencja przychodów (ryczałt) dostosowane do rodzaju działalności klienta.',
                    icon: 'fas fa-book fa-2x'
                },
                {
                    title: 'Rozliczenia podatkowe',
                    description: 'Prawidłowe naliczanie podatków oraz ich terminowe rozliczanie z urzędem skarbowym, w tym deklaracje VAT, PIT, CIT oraz JPK.',
                    icon: 'fas fa-file-invoice-dollar fa-2x'
                },
                {
                    title: 'Obsługa kadrowo-płacowa',
                    description: 'Przygotowanie list płac, zgłoszenia i rozliczenia ZUS oraz prowadzenie akt osobowych pracowników.',
                    icon: 'fas fa-users fa-2x'
                },
                {
                    title: 'Sprawozdania finansowe',
                    description: 'Przygotowanie rocznych sprawozdań finansowych, bilansów i rachunków wyników wymaganych przez urzędy.',
                    icon: 'fas fa-chart-line fa-2x'
                },
                {
                    title: 'Reprezentacja przed urzędami',
                    description: 'Kontakt z urzędem skarbowym i ZUS jako pełnomocnik klienta, odpowiadanie na pisma urzędowe i pomoc przy kontrolach.',
                    icon: 'fas fa-university fa-2x'
                },
                // {
                //     title: 'Doradztwo podatkowe',
                //     description: 'Pomoc w optymalizacji podatkowej i wyborze najkorzystniejszych rozwiązań dla firmy, planowanie kosztów.',
                //     icon: 'fas fa-comments-dollar fa-2x'
                // }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.services-section {
    background-color: #f8f9fa;

    .section-title {
        color: var(--primary-color);
        margin-bottom: 1rem;
    }

    .section-subtitle {
        color: #6c757d;
        max-width: 600px;
        margin: 0 auto;
    }

    .service-card {
        background-color: white;
        padding: 2rem;
        border-radius: 8px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s ease, box-shadow 0.3s ease;

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        }

        .service-icon {
            color: var(--secondary-color);
        }

        .service-title {
            font-size: 1.25rem;
            margin-bottom: 1rem;
            color: var(--primary-color);
        }

        .service-description {
            color: #6c757d;
            font-size: 0.95rem;
        }
    }
}
</style>